import {Intervallo, ObjectFactory, PeriodoType} from "@commons/types";
import {merge} from "lodash";
import {StatoRichiesta} from "@commons/mapping/Workflow";
import {CausaleWFRecord} from "@commons/mapping/CausaleWFRecord";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {DateTime} from "luxon";

export interface QualificheFilter {
    selectAll: boolean,
    DR: boolean,
    QD: boolean,
    IM: boolean,
    IN: boolean,
    OP: boolean,
    AP: boolean,
    altre: boolean,
}

export interface LavoratoriFilter {
    customFired?: Intervallo,
    customForce?: Intervallo
    customHired?: Intervallo,
    fired?: boolean,
    fired_periodo?: string,
    force_periodo?: string,
    glossary?: string[],
    hired?: boolean,
    hired_periodo?: string,
    inForza?: boolean,
    iniziale?: string,
    open?: boolean,
    qualifiche?: QualificheFilter,
    selectAll?: boolean,
    showAllHired?: boolean,
}

export interface Categorie {
    selectAll: boolean,
}

export interface StatiElaborato {
    selectAll: boolean,
    APERTA: boolean,
    CHIUSA: boolean
}

export interface MessaggiStati {
    selectAll: boolean,
}

export interface GAPFilter {
    periodo: string,
    intervallo: Intervallo,
    filtroValido: boolean,
    soloAnnoMese: boolean,
    causale?: any,
    categorie: Categorie,
    statiElaborato: StatiElaborato,
}

export interface CategorieAttivita {
    selectAll: boolean,
    GENERICO?: boolean,
    CONSULENZA?: boolean,
    CED?: boolean
    IT?: boolean,
}

export interface GAPDomainFilter {
    periodo: string,
    intervallo: Intervallo,
    filtroValido: boolean,
    soloAnnoMese: boolean,
    causale: string,
    statoFatturazione?: any,
    idUser?: any,
    categorie: CategorieAttivita,
    statiElaborato: StatiElaborato,
}

export interface TipiAzione {
    selectAll: boolean,
    INVIA_SMS: boolean,
}

export interface StatiAzione {
    selectAll: boolean,
    ESEGUITA_ERRORE: boolean,
}

export interface GAPEventiFilter {
    periodo: string,
    intervallo: Intervallo,
    filtroValido: boolean,
    soloAnnoMese: boolean,
    causale?: any,
    tipiAzione: TipiAzione,
    statiAzione: StatiAzione,
}


export interface Stati {
    selectAll: boolean,
    IN_ATTESA: boolean,
    IN_VALUTAZIONE: boolean,
    ACCETTATA: boolean,
    RIFIUTATA: boolean,
}

export class Stati {
    constructor() {
        this.selectAll = false;
        this.IN_ATTESA = false;
        this.IN_VALUTAZIONE = false;
        this.ACCETTATA = false;
        this.RIFIUTATA = false;
    }

    static fromArray = (stati: StatoRichiesta[]): Stati => {
        const r = new Stati();
        if (!stati || stati.length === 0)
            r.selectAll = true;
        r.IN_ATTESA = stati.includes('IN_ATTESA');
        r.IN_VALUTAZIONE = stati.includes('IN_VALUTAZIONE');
        r.ACCETTATA = stati.includes('ACCETTATA');
        r.RIFIUTATA = stati.includes('RIFIUTATA');
        return r;
    }
}

export interface Validita {
    selectAll: boolean,
    VALIDA: boolean,
    ANNULLATA: boolean,
}

export class Validita {
    constructor() {
        this.selectAll = false;
        this.VALIDA = false;
        this.ANNULLATA = false;
    }

    static fromArray = (stati: ('VALIDA' | 'ANNULLATA')[]): Validita => {
        const r = new Validita();
        if (!stati || stati.length === 0)
            r.selectAll = true;
        r.VALIDA = stati.includes('VALIDA');
        r.ANNULLATA = stati.includes('ANNULLATA');
        return r;
    }
}

export interface Elaborato {
    selectAll: boolean,
    ELABORATO: boolean,
    NON_ELABORATO: boolean,
}

export class Elaborato {
    constructor() {
        this.selectAll = false;
        this.ELABORATO = false;
        this.NON_ELABORATO = false;
    }

    static fromArray = (stati: ('ELABORATO' | 'NON_ELABORATO')[]): Elaborato => {
        const r = new Elaborato();
        if (!stati || stati.length === 0)
            r.selectAll = true;
        r.ELABORATO = stati.includes('ELABORATO');
        r.NON_ELABORATO = stati.includes('NON_ELABORATO');
        return r;
    }
}

// Format per lo slice filtri dello screen gestione richieste
export type FilterPeriodType = {
    type: PeriodoType;
    start: string;
    end: string;
}

export interface FiltersState {
    appliedFilters: boolean;
    STATO: StatoRichiesta[];
    VALIDITA: string[];
    ELABORATO: string[];
    CAUSALE: CausaleWFRecord[];
    PERIODO: FilterPeriodType;
    DIPENDENTE: LavoratorePresenzeRecord[];
}

export interface MonitorWfFilter {
    periodo: PeriodoType,
    intervallo: Intervallo,
    filtroValido: boolean,

    causale: string | null,
    codTabella: string | null,

    stati: Stati,
    statiElaborato: Elaborato,
    validita: Validita,

    salvaFiltro: boolean
}

export class MonitorWfFilter {
    static factory: ObjectFactory<MonitorWfFilter> = (json?) => {
        const today = DateTime.now();
        return merge<MonitorWfFilter, Partial<MonitorWfFilter> | undefined>({
            periodo: 'today',
            intervallo: {startDate: today.startOf('day').toJSDate(), endDate: today.endOf('day').toJSDate()},
            filtroValido: true,

            causale: null,
            codTabella: null,

            stati: {selectAll: true} as Stati,
            statiElaborato: {selectAll: true} as Elaborato,
            validita: {selectAll: true} as Validita,

            salvaFiltro: false
        }, json);
    }
}